import { useOutletContext } from 'react-router'
import { ButtonLinkLegacy } from '@/components/ui/button-link-legacy'
import { PhotosetIndex } from '@/features/photoset/components/photoset-index'
import { qaStepIdToStepSlug } from '@/features/photoset/hooks/use-redirect-qa-photoset'
import { useGetPhotoset } from '@/features/photoset/queries/use-get-photoset'
import type { PhotosetURLParams } from '@/features/photoset/types'
import { qaStepsFlow } from '@/features/photoset/utils'
import { useTranslation } from '@/translations/i18n'

export const Photoset2LaIndex = () => {
	const { t } = useTranslation()
	const { urlParams } = useOutletContext<{ urlParams: PhotosetURLParams }>()
	const { data: photoset, isLoading } = useGetPhotoset(
		{ id: urlParams.id },
		{ enabled: false }
	)

	const _2LaSteps = [
		{
			slug: 'editing-qa-selection',
			label: t('photoset:editingQaSelection.title')
		},
		{
			slug: 'editing-qa-flags',
			label: t('photoset:editingQaFlags.title')
		},
		{
			slug: 'vetting-qa',
			label: t('photoset:vetting_qa.title')
		},
		{
			slug: 'retouching-qa',
			label: t('photoset:retouching_qa.title')
		}
	]

	const is2LaStepLinkEnabled = (qaStepId: string) => {
		if (!photoset?.qa_step_id) {
			return false
		}

		const qaStepKey = photoset.qa_step_id
			? qaStepIdToStepSlug?.[
					photoset.qa_step_id as keyof typeof qaStepIdToStepSlug
				]
			: null
		const selectedStepFlowIndex = qaStepsFlow.indexOf(qaStepId)
		const qaStepFlowIndex = qaStepKey ? qaStepsFlow.indexOf(qaStepKey) : -1

		return qaStepFlowIndex > selectedStepFlowIndex
	}

	return (
		<PhotosetIndex
			endSlot={
				<div className='flex flex-col items-center gap-4'>
					<ul>
						{_2LaSteps.map((step) => (
							<li key={step.slug}>
								<ButtonLinkLegacy
									disabled={!is2LaStepLinkEnabled(step.slug)}
									to={`/photoset/${urlParams.id}/2la/${step.slug}`}
									variant='tertiary'
								>
									{step.label}
								</ButtonLinkLegacy>
							</li>
						))}
					</ul>
				</div>
			}
			isLoading={isLoading}
			title={t('photoset:2la_index.title')}
		/>
	)
}
